/*
 * File: TeamColumnGrid.tsx
 * Project: a-a
 * File Created: Wednesday, 15th January 2025 8:48:47 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Friday, 1st May 2026 4:20:08 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box } from '@mui/material';
import React from 'react';
import CustomClientCard from '../Client/CustomClientCard';
import { Link } from 'react-router-dom';
import zeplinColor from '../../../theme/Color';
import CustomMemberCard from './CustomMemberCard';
import { useAppDispatch } from '../../../store/hooks';
import { setCurrentTab, setSelectedMember } from '../../../store/slices/teamUiSlice';

type Team = {
  id: string | null;
  position: string | null;
  name: string | null;
  mobile: string | null;
  phone: string | null;
  address: {
    city: string | null;
    country: string | null;
    geocodeAccuracy: string | null;
    latitude: string | null;
    longitude: string | null;
    postalCode: string | null;
    state: string | null;
    street: string | null;
  };
  company: string | null;
  email: string | null;
  openDeals: string | null;
  openTasks: string | null;
  title: string | null;
  profile_image_url: string | null;
  assignmentCount: number | null;
  workLoadCapacity: number | null;
};
type TeamData = {
  members: Team[];
};

const TeamColumnGrid = ({
  teams,
  loading,
  category,
}: {
  teams: TeamData;
  loading: boolean;
  category: string | null;
}) => {
  const dispatch = useAppDispatch();

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          // gridTemplateColumns: 'repeat(5, 1fr)',
          gridTemplateColumns: {
            xs: 'repeat(auto-fill, minmax(250px, 1fr))', // Responsive columns
            sm: 'repeat(auto-fill, minmax(270px, 1fr))',
            md: 'repeat(auto-fill, minmax(280px, 1fr))',
            lg: 'repeat(auto-fill, minmax(290px, 1fr))',
            xl: 'repeat(auto-fill, minmax(300px, 1fr))',
          },
          gap: '24px',
          overflowY: 'scroll',
          // height: '65vh',
          // height: window.innerHeight - 250,
          // height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
          gridAutoRows: 'min-content', // Make rows only as tall as content
          gridAutoFlow: 'row',
          // height: '65vh',
          height: { xs: 'calc(100vh - 190px)', xl: 'calc(100vh - 250px)' },
          alignItems: 'start',
          '& > a': {
            // Target all Link elements directly inside the grid
            height: 'auto',
            display: 'block',
          },
        }}
      >
        {loading
          ? [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map((val) => (
              <CustomMemberCard
                key={val}
                member={{
                  id: '',
                  position: '',
                  name: '',
                  mobile: '',
                  phone: '',
                  address: {
                    city: '',
                    country: '',
                    geocodeAccuracy: '',
                    latitude: '',
                    longitude: '',
                    postalCode: '',
                    state: '',
                    street: '',
                  },
                  company: '',
                  email: '',
                  openDeals: '',
                  openTasks: '',
                  title: '',
                  assignmentCount: null,
                  workLoadCapacity: null,
                }}
                loading={true}
              />
            ))
          : teams?.members?.map((val: Team) => (
              <Link
                to={val.id || ''}
                onClick={(event) => {
                  const clickedAssignmentButton = (event.target as HTMLElement)?.closest(
                    '[data-assignment-trigger="true"]',
                  );
                  dispatch(setSelectedMember(val));
                  dispatch(setCurrentTab(clickedAssignmentButton ? 2 : 0));
                }}
                style={{
                  textDecoration: 'none',
                  color: zeplinColor.BasicBlack,
                  // display: 'contents',
                }}
              >
                {' '}
                <CustomMemberCard key={val.id} member={val} loading={loading} />
              </Link>
            ))}
      </Box>
    </>
  );
};

export default TeamColumnGrid;
